/**
 *
 * Add .js class to body tag if JavaScript is enabled
 *
 * @since 1.0.0
 *
 */
document.getElementsByTagName( "body" )[0].className += " js";

(function( $ ) {

	$( document ).ready( function() {

		/**
		 *
		 * Place your jQuery code here.
		 *
		 */
	});

})(jQuery);
